import { Component, input, Input } from '@angular/core';
import { Game } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-ui-game-details',
  templateUrl: './game-details.component.html',
  styleUrls: ['./game-details.component.scss'],
})
export class GameUiDetailsComponent {
  @Input()
  tournament: {
    name: string;
    overview: string;
  } | null;
  @Input()
  game: Game | null;

  startDate = input<Date>();
  endDate = input<Date>();
}
